/* eslint-disable jsx-a11y/no-distracting-elements */
import "./postplayingtemplatefive.css";
import { React, ReactPlayer } from "../../../Libraries/Post/PostPlaying/index";
import DOMPurify from 'dompurify';
const PostPlayingTemplateFive = (props) => {
  return (
    <div className="l5playing">
      <div className="sidebararea">
        <div className="sidebarwrapper">
          <marquee direction="up" style={{ height: "100%" }}>
            {props?.data?.sidebar.map((sidebarcontent, index) => (
              <div
                className="row flex-column justify-content-center p-3"
                key={index}
              >
                <div className="col fs-1">
                  {sidebarcontent.txt_sidebar_title}
                </div>
                <div className="col">
                  {sidebarcontent.txt_sidebar_description}
                </div>
              </div>
            ))}
          </marquee>
        </div>
      </div>
      {props?.data?.finalfile?.txt_media_file_type === "Image" ? (
        <div className="mianarea">
          <img
            src={props?.data?.finalfile.txt_media_streaming_link}
            alt="img"
            width="100%"
            height="100%"
          />
        </div>
      ) : props?.data?.finalfile?.txt_media_file_type === "Video" ||
        props?.data?.finalfile?.txt_media_file_type === "Live" ? (
        <div className="mianarea">
          <ReactPlayer
            url={props.data.finalfile.txt_media_streaming_link}
            loop={true}
            playing={true}
            playsInline
            width="100%"
            height="100%"
            controls
          />
        </div>
      ) : props?.data?.finalfile?.txt_media_file_type === "Widget" ? (
        <div className="mainarea">
          {/* <div
            dangerouslySetInnerHTML={{
              // __html: props?.data?.finalfile?.txt_media_streaming_link,
              __html: DOMPurify.sanitize(props?.data?.finalfile?.txt_media_streaming_link),
            }}
            style={{ height: "100%" }}
          /> */}
        <p>{props?.data?.finalfile?.txt_media_streaming_link}</p>
        </div>
      ) : null}
    </div>
  );
};

export default PostPlayingTemplateFive;
